import * as React from "react";
import {
  List, Datagrid, TextField, FunctionField, Show, SimpleShowLayout,
} from "react-admin";
import { JsonField } from "../../components/JsonField";
import { TechInfo } from "../../components/ui";

// MigrationLog : id (= name), name, appliedAt (epoch ms), note.
export default {
  list: () => (
    <List sort={{ field: "appliedAt", order: "DESC" }} perPage={50} pagination={false}>
      <Datagrid rowClick="show" bulkActionButtons={false}>
        <TextField source="name" label="Migration" />
        <FunctionField label="Appliquée le" render={(r) => r?.appliedAt
          ? new Date(Number(r.appliedAt)).toLocaleString("fr-FR") : "—"} />
        <TextField source="note" />
      </Datagrid>
    </List>
  ),
  show: () => (
    <Show>
      <SimpleShowLayout>
        <TextField source="name" />
        <FunctionField label="Appliquée le" render={(r) => r?.appliedAt
          ? new Date(Number(r.appliedAt)).toLocaleString("fr-FR") : "—"} />
        <TextField source="note" />
        <JsonField source="__all__" />
        <TechInfo />
        </SimpleShowLayout>
    </Show>
  ),
};
